import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mb-3" };
const _hoisted_2 = { class: "mb-3" };
const _hoisted_3 = { class: "mb-3" };
const _hoisted_4 = { class: "alert-heading" };
const _hoisted_5 = { class: "mb-2" };
const _hoisted_6 = { class: "mb-0" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { key: 2 };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "form-check" };
const _hoisted_12 = ["disabled"];
const _hoisted_13 = { class: "text-muted d-block mt-2" };
const _hoisted_14 = { class: "form-check mb-2" };
const _hoisted_15 = ["disabled"];
const _hoisted_16 = { class: "form-check" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_19 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_20 = { class: "alert-heading" };
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { class: "mb-1" };
const _hoisted_23 = {
    key: 0,
    class: "mb-1"
};
const _hoisted_24 = {
    key: 1,
    class: "mb-1"
};
const _hoisted_25 = { class: "mb-1" };
const _hoisted_26 = { class: "mb-1" };
const _hoisted_27 = { class: "mb-1" };
const _hoisted_28 = { key: 1 };
const _hoisted_29 = { class: "mb-0" };
const _hoisted_30 = { key: 0 };
const _hoisted_31 = { key: 1 };
const _hoisted_32 = { key: 2 };
const _hoisted_33 = { key: 3 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_file = _resolveComponent("b-form-file");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_b_progress = _resolveComponent("b-progress");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        id: "import-system-from-zip-modal",
        class: "modal-form-lg",
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.show) = $event)),
        title: "Import System from ZIP",
        "header-bg-variant": "normal",
        size: "lg",
        onHidden: _ctx.onModalHidden
    }, {
        footer: _withCtx(() => [
            _createVNode(_component_b_button, {
                type: "button",
                variant: "secondary",
                onClick: _ctx.cancel,
                disabled: _ctx.uploading
            }, {
                default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                        _createTextVNode("Cancel", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick", "disabled"]),
            _cache[74] || (_cache[74] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: _ctx.getButtonVariant,
                onClick: _ctx.importFile,
                disabled: !_ctx.canImport
            }, {
                default: _withCtx(() => [
                    (_ctx.uploading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, [...(_cache[70] || (_cache[70] = [
                                _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                                _createTextVNode(" Importing...", -1 /* CACHED */)
                            ]))]))
                        : (_ctx.existingSystemWarning && _ctx.selectedImportOption === 'override')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, [...(_cache[71] || (_cache[71] = [
                                    _createElementVNode("i", { class: "fa fa-sync" }, null, -1 /* CACHED */),
                                    _createTextVNode(" Override & Import\r\n\t\t\t\t", -1 /* CACHED */)
                                ]))]))
                            : (_ctx.existingSystemWarning && (_ctx.selectedImportOption === 'archive' || _ctx.archiveExisting))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, [...(_cache[72] || (_cache[72] = [
                                        _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1 /* CACHED */),
                                        _createTextVNode(" Archive & Import\r\n\t\t\t\t", -1 /* CACHED */)
                                    ]))]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_33, [...(_cache[73] || (_cache[73] = [
                                        _createElementVNode("i", { class: "fa fa-upload" }, null, -1 /* CACHED */),
                                        _createTextVNode(" Import", -1 /* CACHED */)
                                    ]))]))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["variant", "onClick", "disabled"])
        ]),
        default: _withCtx(() => {
            var _a;
            return [
                _createElementVNode("div", _hoisted_1, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, [
                        _createTextVNode("Company "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1 /* CACHED */)),
                    _cache[10] || (_cache[10] = _createTextVNode()),
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedCompany,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompany) = $event)),
                        options: _ctx.companies,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "Select company",
                        class: "multiselect-small",
                        disabled: _ctx.uploading
                    }, {
                        noResult: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                ]),
                _cache[75] || (_cache[75] = _createTextVNode()),
                _createElementVNode("div", _hoisted_2, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, [
                        _createTextVNode("Site "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1 /* CACHED */)),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedSite,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                        options: _ctx.filteredSites,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "Select site",
                        class: "multiselect-small",
                        disabled: _ctx.uploading || !_ctx.selectedCompany
                    }, {
                        noResult: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                ]),
                _cache[76] || (_cache[76] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, [
                        _createTextVNode("ZIP File "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1 /* CACHED */)),
                    _cache[15] || (_cache[15] = _createTextVNode()),
                    _createVNode(_component_b_form_file, {
                        modelValue: _ctx.selectedFile,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.selectedFile) = $event)),
                        accept: ".zip",
                        placeholder: "Choose a ZIP file or drop it here...",
                        "drop-placeholder": "Drop ZIP file here...",
                        disabled: _ctx.uploading,
                        onChange: _ctx.onFileSelected
                    }, null, 8 /* PROPS */, ["modelValue", "disabled", "onChange"]),
                    _cache[16] || (_cache[16] = _createTextVNode()),
                    _cache[17] || (_cache[17] = _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\tThe ZIP file must contain: configuration.json, limits.json, and optional CSV files (clog-Yearly*.csv, tlog-charge*.csv, tlog-discharge*.csv)\r\n\t\t\t", -1 /* CACHED */))
                ]),
                _cache[77] || (_cache[77] = _createTextVNode()),
                _cache[78] || (_cache[78] = _createTextVNode()),
                _createVNode(_component_b_alert, {
                    modelValue: _ctx.showExistingSystemWarning,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.showExistingSystemWarning) = $event)),
                    variant: ((_a = _ctx.existingSystemWarning) === null || _a === void 0 ? void 0 : _a.isDifferentLocation) ? 'danger' : 'warning',
                    dismissible: "",
                    class: "mb-3"
                }, {
                    default: _withCtx(() => {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                        return [
                            _createElementVNode("h5", _hoisted_4, [
                                _createElementVNode("i", {
                                    class: _normalizeClass(((_a = _ctx.existingSystemWarning) === null || _a === void 0 ? void 0 : _a.isDifferentLocation) ? 'fa fa-exclamation-circle' : 'fa fa-exclamation-triangle')
                                }, null, 2 /* CLASS */),
                                _createTextVNode(" " + _toDisplayString(((_b = _ctx.existingSystemWarning) === null || _b === void 0 ? void 0 : _b.isDifferentLocation) ? 'Controller Found in Different Location' : 'Existing System Found'), 1 /* TEXT */)
                            ]),
                            _cache[41] || (_cache[41] = _createTextVNode()),
                            _createElementVNode("p", null, _toDisplayString((_c = _ctx.existingSystemWarning) === null || _c === void 0 ? void 0 : _c.message), 1 /* TEXT */),
                            _cache[42] || (_cache[42] = _createTextVNode()),
                            _cache[43] || (_cache[43] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                            _cache[44] || (_cache[44] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_5, [
                                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "mb-1" }, [
                                    _createElementVNode("strong", null, "Existing System Details:")
                                ], -1 /* CACHED */)),
                                _cache[25] || (_cache[25] = _createTextVNode()),
                                _createElementVNode("ul", _hoisted_6, [
                                    _createElementVNode("li", null, [
                                        _cache[18] || (_cache[18] = _createElementVNode("strong", null, "System Name:", -1 /* CACHED */)),
                                        _createTextVNode(" " + _toDisplayString((_d = _ctx.existingSystemWarning) === null || _d === void 0 ? void 0 : _d.existingSystem.systemName), 1 /* TEXT */)
                                    ]),
                                    _cache[22] || (_cache[22] = _createTextVNode()),
                                    (((_e = _ctx.existingSystemWarning) === null || _e === void 0 ? void 0 : _e.existingSystem.serialNumber) !== 'N/A')
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                                            _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Serial Number:", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString((_f = _ctx.existingSystemWarning) === null || _f === void 0 ? void 0 : _f.existingSystem.serialNumber), 1 /* TEXT */)
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[23] || (_cache[23] = _createTextVNode()),
                                    ((_g = _ctx.existingSystemWarning) === null || _g === void 0 ? void 0 : _g.isDifferentLocation)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                                            _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Current Location:", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString((_h = _ctx.existingSystemWarning) === null || _h === void 0 ? void 0 : _h.existingSystem.companyName) + " / " + _toDisplayString((_j = _ctx.existingSystemWarning) === null || _j === void 0 ? void 0 : _j.existingSystem.siteName), 1 /* TEXT */)
                                        ]))
                                        : (_openBlock(), _createElementBlock("li", _hoisted_9, [
                                            _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Site:", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString((_k = _ctx.existingSystemWarning) === null || _k === void 0 ? void 0 : _k.existingSystem.siteName), 1 /* TEXT */)
                                        ]))
                                ])
                            ]),
                            _cache[45] || (_cache[45] = _createTextVNode()),
                            _cache[46] || (_cache[46] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                            _cache[47] || (_cache[47] = _createTextVNode()),
                            _createCommentVNode(" Different Location: Only Archive option "),
                            _cache[48] || (_cache[48] = _createTextVNode()),
                            ((_l = _ctx.existingSystemWarning) === null || _l === void 0 ? void 0 : _l.isDifferentLocation)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.archiveExisting) = $event)),
                                            id: "archiveCheck",
                                            disabled: _ctx.uploading
                                        }, null, 8 /* PROPS */, _hoisted_12), [
                                            [_vModelCheckbox, _ctx.archiveExisting]
                                        ]),
                                        _cache[26] || (_cache[26] = _createTextVNode()),
                                        _cache[27] || (_cache[27] = _createElementVNode("label", {
                                            class: "form-check-label",
                                            for: "archiveCheck"
                                        }, "\r\n\t\t\t\t\t\tI understand that the existing system will be archived and moved to the selected company/site.\r\n\t\t\t\t\t", -1 /* CACHED */))
                                    ]),
                                    _cache[29] || (_cache[29] = _createTextVNode()),
                                    _createElementVNode("small", _hoisted_13, [
                                        _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1 /* CACHED */)),
                                        _createTextVNode("\r\n\t\t\t\t\tThe existing system in " + _toDisplayString((_m = _ctx.existingSystemWarning) === null || _m === void 0 ? void 0 : _m.existingSystem.companyName) + " / " + _toDisplayString((_o = _ctx.existingSystemWarning) === null || _o === void 0 ? void 0 : _o.existingSystem.siteName) + " \r\n\t\t\t\t\twill be renamed with an \"_ARCHIVED_\" suffix and marked as deleted. The controller will be imported to the selected location.\r\n\t\t\t\t", 1 /* TEXT */)
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" Same Location: Both Archive and Override options "),
                                    _createElementVNode("div", null, [
                                        _cache[38] || (_cache[38] = _createElementVNode("p", { class: "mb-2" }, [
                                            _createElementVNode("strong", null, "Choose an option:")
                                        ], -1 /* CACHED */)),
                                        _cache[39] || (_cache[39] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_14, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                name: "importOption",
                                                id: "overrideOption",
                                                value: "override",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedImportOption) = $event)),
                                                disabled: _ctx.uploading
                                            }, null, 8 /* PROPS */, _hoisted_15), [
                                                [_vModelRadio, _ctx.selectedImportOption]
                                            ]),
                                            _cache[30] || (_cache[30] = _createTextVNode()),
                                            _cache[31] || (_cache[31] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "overrideOption"
                                            }, [
                                                _createElementVNode("strong", null, "Override existing system"),
                                                _createTextVNode(" (update/merge data)\r\n\t\t\t\t\t")
                                            ], -1 /* CACHED */)),
                                            _cache[32] || (_cache[32] = _createTextVNode()),
                                            _cache[33] || (_cache[33] = _createElementVNode("small", { class: "text-muted d-block ms-4" }, "\r\n\t\t\t\t\t\tThe existing system will be updated with the imported data. Existing components will be updated by code, \r\n\t\t\t\t\t\tand new components will be added. Duplicate snapshots and events will be skipped.\r\n\t\t\t\t\t", -1 /* CACHED */))
                                        ]),
                                        _cache[40] || (_cache[40] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_16, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                name: "importOption",
                                                id: "archiveOption",
                                                value: "archive",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.selectedImportOption) = $event)),
                                                disabled: _ctx.uploading
                                            }, null, 8 /* PROPS */, _hoisted_17), [
                                                [_vModelRadio, _ctx.selectedImportOption]
                                            ]),
                                            _cache[34] || (_cache[34] = _createTextVNode()),
                                            _cache[35] || (_cache[35] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "archiveOption"
                                            }, [
                                                _createElementVNode("strong", null, "Archive existing and create new"),
                                                _createTextVNode(" (replace system)\r\n\t\t\t\t\t")
                                            ], -1 /* CACHED */)),
                                            _cache[36] || (_cache[36] = _createTextVNode()),
                                            _cache[37] || (_cache[37] = _createElementVNode("small", { class: "text-muted d-block ms-4" }, "\r\n\t\t\t\t\t\tThe existing system will be renamed with an \"_ARCHIVED_\" suffix and marked as deleted. \r\n\t\t\t\t\t\tAll its components will also be archived. A completely new system will be created from the imported data.\r\n\t\t\t\t\t", -1 /* CACHED */))
                                        ])
                                    ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "variant"]),
                _cache[79] || (_cache[79] = _createTextVNode()),
                (_ctx.uploadProgress > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[49] || (_cache[49] = _createElementVNode("label", { class: "form-label" }, "Upload Progress", -1 /* CACHED */)),
                        _cache[50] || (_cache[50] = _createTextVNode()),
                        _createVNode(_component_b_progress, {
                            value: _ctx.uploadProgress,
                            max: 100,
                            "show-progress": "",
                            animated: ""
                        }, null, 8 /* PROPS */, ["value"])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[80] || (_cache[80] = _createTextVNode()),
                (_ctx.importResult)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_b_alert, {
                            variant: _ctx.importResult.success ? 'success' : 'danger',
                            show: ""
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.importResult.success ? 'Success!' : 'Error'), 1 /* TEXT */),
                                _cache[66] || (_cache[66] = _createTextVNode()),
                                _createElementVNode("p", null, _toDisplayString(_ctx.importResult.message), 1 /* TEXT */),
                                _cache[67] || (_cache[67] = _createTextVNode()),
                                (_ctx.importResult.success && _ctx.importResult.systemId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createElementVNode("p", _hoisted_22, [
                                            _cache[51] || (_cache[51] = _createElementVNode("strong", null, "System ID:", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.importResult.systemId), 1 /* TEXT */)
                                        ]),
                                        _cache[57] || (_cache[57] = _createTextVNode()),
                                        (_ctx.importResult.archivedSystemId)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                                                _cache[52] || (_cache[52] = _createElementVNode("strong", null, "Archived System ID:", -1 /* CACHED */)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.importResult.archivedSystemId), 1 /* TEXT */)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[58] || (_cache[58] = _createTextVNode()),
                                        (_ctx.importResult.overriddenSystemId)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                                _cache[53] || (_cache[53] = _createElementVNode("strong", null, "Updated System ID:", -1 /* CACHED */)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.importResult.overriddenSystemId), 1 /* TEXT */)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[59] || (_cache[59] = _createTextVNode()),
                                        _createElementVNode("p", _hoisted_25, [
                                            _cache[54] || (_cache[54] = _createElementVNode("strong", null, "Snapshots Imported:", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.importResult.snapshotsImported), 1 /* TEXT */)
                                        ]),
                                        _cache[60] || (_cache[60] = _createTextVNode()),
                                        _createElementVNode("p", _hoisted_26, [
                                            _cache[55] || (_cache[55] = _createElementVNode("strong", null, "Charge Events:", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.importResult.chargeEventsImported), 1 /* TEXT */)
                                        ]),
                                        _cache[61] || (_cache[61] = _createTextVNode()),
                                        _createElementVNode("p", _hoisted_27, [
                                            _cache[56] || (_cache[56] = _createElementVNode("strong", null, "Discharge Events:", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.importResult.dischargeEventsImported), 1 /* TEXT */)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _cache[68] || (_cache[68] = _createTextVNode()),
                                (!_ctx.importResult.success && _ctx.importResult.errors && _ctx.importResult.errors.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        _cache[62] || (_cache[62] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                                        _cache[63] || (_cache[63] = _createTextVNode()),
                                        _cache[64] || (_cache[64] = _createElementVNode("p", { class: "mb-1" }, [
                                            _createElementVNode("strong", null, "Errors:")
                                        ], -1 /* CACHED */)),
                                        _cache[65] || (_cache[65] = _createTextVNode()),
                                        _createElementVNode("ul", _hoisted_29, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importResult.errors, (error, index) => {
                                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1 /* TEXT */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["variant"])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[81] || (_cache[81] = _createTextVNode())
            ];
        }),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onHidden"]));
}
